module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "banner__title"
  }, [_vm._v("Aprenda a\n            "), _c('br'), _vm._v("controlar suas\n            "), _c('br'), _vm._v("finanças com\n            "), _c('br'), _vm._v("apenas um toque!\n          ")]), _vm._v(" "), _c('p', [_vm._v("Teste GRÁTIS por uma semana!*")]), _vm._v(" "), _c('p', {
    staticClass: "condition"
  }, [_vm._v("*Após esse período, assinatura de R$5,19 por semana")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-light font-weight-bold btn-lg mr-4",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=br.com.mlearn.timfinancas",
      "target": "_blank"
    }
  }, [_vm._v("ANDROID")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn btn-light font-weight-bold btn-lg",
    attrs: {
      "href": "https://app.timfinancas.com.br",
      "target": "_blank"
    }
  }, [_vm._v("VERSÃO WEB")]), _vm._v(" "), _c('span', [_vm._v("\n            Envie um SMS para\n            "), _c('strong', [_vm._v("6634")]), _vm._v(" com a palavra\n            "), _c('strong', [_vm._v("OK")]), _vm._v(" e aproveite\n            "), _c('br'), _vm._v("todos os benefícios!\n          ")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "call"
  }, [_c('div', {
    staticClass: "container-fluid text-center"
  }, [_c('h2', {
    staticClass: "call__title"
  }, [_vm._v("Mais de 1 milhão de pessoas já\n        "), _c('br'), _vm._v("aprenderam com o TIM finanças!\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "financas"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "financas__title"
  }, [_vm._v("Aprenda sobre finanças no seu smartphone")]), _vm._v(" "), _c('p', [_vm._v("\n            O\n            "), _c('strong', [_vm._v("TIM finanças")]), _vm._v("\n            é um guia prático, com todas as informações necessárias para que você possa manter a sua saúde financeira e profissional em dia!\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Ele vai te ajudar a controlar suas finanças pessoais, fazendo com que você seja capaz de gerenciar melhor suas receitas e despesas, identificar para onde estão indo os seus gastos e ainda abrir e gerenciar sua empresa.")]), _vm._v(" "), _c('p', {
    staticClass: "financas__info"
  }, [_vm._v("Primeira semana GRÁTIS*")]), _vm._v(" "), _c('span', [_vm._v("*Após esse período, assinatura de R$5,19 por semana")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary font-weight-bold btn-lg mr-4",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=br.com.mlearn.timfinancas",
      "target": "_blank"
    }
  }, [_vm._v("\n            ANDROID\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn btn-primary font-weight-bold btn-lg",
    attrs: {
      "href": "https://app.timfinancas.com.br",
      "target": "_blank"
    }
  }, [_vm._v("VERSÃO WEB")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/app-screens.png")
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "duvidas"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('img', {
    staticClass: "mb-5",
    attrs: {
      "src": require("assets/img/porco.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "duvidas__title"
  }, [_vm._v("Possui dúvidas financeiras?")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Aprimore seu controle financeiro!")]), _vm._v(" "), _c('br'), _vm._v("Esclareça suas dúvidas com nossos especialistas em finanças e aprenda melhores práticas para gerenciar sua vida financeira e a da sua empresa.\n          ")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "aprender"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "aprender__title"
  }, [_vm._v("O que você vai aprender")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-3 aprender__single"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/financas.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Finanças Pessoais")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3 aprender__single"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/investimentos.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Investimentos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3 aprender__single"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/negociacao.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Técnicas de Negociação")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-3 aprender__single"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/empreendedorismo.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Empreendedorismo")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "certificao"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "certificao__title"
  }, [_vm._v("Certicação reconhecida")]), _vm._v(" "), _c('p', [_vm._v("Além de ter acesso a um conteúdo de qualidade, você ainda recebe, ao final, um certificado da mLearn reconhecido pelo mercado de trabalho.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "d-block ml-auto mr-auto mt-5",
    attrs: {
      "src": require("assets/img/abed.png")
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "alunos"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "alunos__title"
  }, [_vm._v("O que dizem nossos alunos")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 alunos-single"
  }, [_c('h3', {
    staticClass: "alunos-single__title"
  }, [_vm._v("Alice Moura")]), _vm._v(" "), _c('p', {
    staticClass: "alunos-single__text"
  }, [_vm._v("\"Adorei os cursos, fácil de usar! Super recomendo.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 alunos-single"
  }, [_c('h3', {
    staticClass: "alunos-single__title"
  }, [_vm._v("Gustavo Oliveira")]), _vm._v(" "), _c('p', {
    staticClass: "alunos-single__text"
  }, [_vm._v("\"Dicas Práticas do dia a dia!\"")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 alunos-single"
  }, [_c('h3', {
    staticClass: "alunos-single__title"
  }, [_vm._v("Thiago Diniz")]), _vm._v(" "), _c('p', {
    staticClass: "alunos-single__text"
  }, [_vm._v("\"Bem dinâmico e organizado, conteúdo bem objetivo!\"")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "features container",
    attrs: {
      "id": "recursos"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "features__title"
  }, [_vm._v("O que você pode fazer no TIM Finanças")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/livro.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Conteúdos em Texto")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/lapis.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Exercícios")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/mic.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Podcasts")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/video.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Vídeos")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/wifi.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Modo Offline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/certificado.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Certificados")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/lamp.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Dicas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-6 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/game.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Gamification")])])])]), _vm._v(" "), _c('section', {
    staticClass: "dispositivos"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "dispositivos__title"
  }, [_vm._v("Acesse o app em diversos dispositivos")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/img/telas.png"),
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "assine",
    attrs: {
      "id": "assine"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticClass: "assine__title"
  }, [_vm._v("Assine agora!")]), _vm._v(" "), _c('p', [_vm._v("\n            Envie um SMS para\n            "), _c('strong', [_vm._v("6634")]), _vm._v(" com a palavra\n            "), _c('strong', [_vm._v("OK")]), _vm._v(" e aproveite todos os benefícios!\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "assine__info"
  }, [_c('p', [_vm._v("Ou baixe o app TIM Finanças")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-light font-weight-bold btn-lg mr-4",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=br.com.mlearn.timfinancas",
      "target": "_blank"
    }
  }, [_vm._v("ANDROID")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn btn-light font-weight-bold btn-lg",
    attrs: {
      "href": "https://app.timfinancas.com.br",
      "target": "_blank"
    }
  }, [_vm._v("VERSÃO WEB")]), _vm._v(" "), _c('span', [_vm._v("Primeira semana grátis. Após, assinatura de R$5,19 por semana.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('img', {
    staticClass: "img-fluid mr-sm-0 mt-5 m-auto mt-sm-0 d-block",
    attrs: {
      "src": require("assets/img/app.png"),
      "alt": ""
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c103536","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/Home.vue
// module id = 354
// module chunks = 1